import React, { useEffect, useState } from 'react';
import { Grid, TextField, Typography, Paper, MenuItem, FormControlLabel, Checkbox, Divider, FormHelperText } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { cargarCatalogo } from '../../components/CargarCatalogoBienestar';
import { INDENTIDAD_GENERO_BIENESTAR } from '../../../helper';

/* =======================
    STEP 1 — Identificación del Ofensor
   ======================= */
function IdentificacionOfensor({ state, onChange, solicitud }) {
    const safeValue = (field) => (state?.[field]?.valor || '');
    const safeError = (field) => (state?.[field]?.error || '');
    const theme = useTheme();
    const [identidadGenero, setIdentidadGenero] = useState([]);

        useEffect(() => {
    
                if (solicitud?.usuario_registro) {
        
                    const usuario = solicitud.usuario_registro;
        
                    const nombreCompleto = `
                        ${usuario.primer_nombre || ''} 
                        ${usuario.segundo_nombre || ''} 
                        ${usuario.primer_apellido || ''} 
                        ${usuario.segundo_apellido || ''}
                    `.replace(/\s+/g, ' ').trim();
    
                    onChange({
                        target: {
                            name: 'nombre_ofensor',
                            value: nombreCompleto
                        }
                    });
        
                    onChange({
                        target: {
                            name: 'documento_identidad',
                            value: usuario.identificacion || ''
                        }
                    });
    
                    onChange({
                        target: {
                            name: 'numero_contacto',
                            value: usuario.celular || usuario.telefono || ''
                        }
                    });
    
                    onChange({
                        target: {
                            name: 'correo_electronico',
                            value: usuario.correo_personal || ''
                        }
                    });
                }
                    const cargarTodo = async () => {
                        await Promise.all([
                            cargarCatalogo(INDENTIDAD_GENERO_BIENESTAR, setIdentidadGenero),
                        ]);
                    };
                        cargarTodo();
            }, [solicitud]);

    return (
        <Grid container spacing={3}>

            <Grid item xs={12} md={6}>
                <TextField
                    disabled
                    fullWidth
                    label="Nombre completo de la persona ofensora"
                    name="nombre_ofensor"
                    value={safeValue('nombre_ofensor')}
                    onChange={onChange}
                    error={!!safeError('nombre_ofensor')}
                    helperText={safeError('nombre_ofensor')}
                />
            </Grid>

            <Grid item xs={12} md={6}>
                <TextField
                    disabled
                    fullWidth
                    label="No. de documento de Identidad"
                    name="documento_identidad"
                    value={safeValue('documento_identidad')}
                    onChange={onChange}
                    error={!!safeError('documento_identidad')}
                    helperText={safeError('documento_identidad')}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    label="Lugar de expedición"
                    name="lugar_expedicion"
                    value={safeValue('lugar_expedicion')}
                    onChange={onChange}
                    error={!!safeError('lugar_expedicion')}
                    helperText={safeError('lugar_expedicion')}
                />
            </Grid>

            
            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    label="Número de contacto"
                    name="numero_contacto"
                    value={safeValue('numero_contacto')}
                    onChange={onChange}
                    error={!!safeError('numero_contacto')}
                    helperText={safeError('numero_contacto')}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    label="Edad"
                    name="edad_ofensor"
                    type="number"
                    value={safeValue('edad_ofensor')}
                    onChange={onChange}
                    error={!!safeError('edad_ofensor')}
                    helperText={safeError('edad_ofensor')}
                />
            </Grid>

            <Grid item xs={12} md={6}>
                <TextField
                    select
                    fullWidth
                    label="Identidad de género"
                    name="identidad_genero"
                    value={safeValue('identidad_genero')}
                    onChange={onChange}
                    error={!!safeError('identidad_genero')}
                    helperText={safeError('identidad_genero')}
                >
                    {identidadGenero.map((opcion) => (
                        <MenuItem key={opcion.value} value={opcion.label}>
                        {opcion.label}
                        </MenuItem>
                    ))}
                </TextField>
            </Grid>

            <Grid item xs={12} md={6}>
                <TextField
                    select
                    fullWidth
                    label="Vínculo con la Universidad"
                    name="vinculo_univeritario"
                    value={safeValue('vinculo_univeritario')}
                    onChange={onChange}
                    error={!!safeError('vinculo_univeritario')}
                    helperText={safeError('vinculo_univeritario')}
                >
                    <MenuItem value="Estudiante">Estudiante</MenuItem>
                    <MenuItem value="Docente">Docente</MenuItem>
                    <MenuItem value="Administrativo">Administrativo</MenuItem>
                    <MenuItem value="Otro">Otro</MenuItem>
                </TextField>
            </Grid>

            <Grid item xs={12} md={6}>
                <TextField
                    fullWidth
                    label="Teléfono / medio de contacto"
                    name="contacto_ofensor"
                    value={safeValue('contacto_ofensor')}
                    onChange={onChange}
                    error={!!safeError('contacto_ofensor')}
                    helperText={safeError('contacto_ofensor')}
                />
            </Grid>

            <Grid item xs={12} md={6}>
                <TextField
                    fullWidth
                    label="Correo electrónico"
                    name="correo_electronico"
                    type="email"
                    value={safeValue('correo_electronico')}
                    onChange={onChange}
                    error={!!safeError('correo_electronico')}
                    helperText={safeError('correo_electronico')}
                />
            </Grid>


        </Grid>
    );
}

/* =======================
    STEP 2 — Información Socializada y Decisión
   ======================= */
function SocializacionDecision({ state, onChange }) {
    const safeValue = (field) => (state?.[field]?.valor || '');
    const safeError = (field) => (state?.[field]?.error || '');

const handleCheck = (name, e) => {
        onChange({ 
            target: { 
                name, 
                value: e.target.checked ? "SI" : "NO"
            } 
        });
    };

    const aceptaParticipar = safeValue('acepta_proceso_restaurativo') === 'SI';

    return (
        <Grid container spacing={3}>

            <Grid item xs={12}>
                    <Typography variant="subtitle2" color="primary">Información Socializada:</Typography>
            </Grid>

{[
    { label: 'Proceso restaurativo activado por la persona afectada', name: 'inf_proceso_activado' },
    { label: 'Medidas construidas por la persona afectada', name: 'inf_medidas_construidas' },
    { label: 'Finalidad del proceso y sus límites', name: 'inf_finalidad_limites' },
    { label: 'Que la participación debe ser voluntaria, y no reemplaza procesos disciplinarios o legales', name: 'inf_voluntariedad' }
].map((item) => (
    <Grid item xs={12} md={6} key={item.name}>
        <FormControlLabel
            control={
                <Checkbox
                    checked={safeValue(item.name) === "SI"}
                    onChange={(e) => handleCheck(item.name, e)}
                    color="primary"
                />
            }
            label={item.label}
        />
    </Grid>
))}

            <Grid item xs={12}>
                {safeError('informacion_socializada') && (
                    <FormHelperText error>
                        {safeError('informacion_socializada')}
                    </FormHelperText>
                )}
            </Grid>

            <Grid item xs={12} md={12}>
                <TextField
                    select
                    fullWidth
                    label="¿Comprende el objetivo del proceso restaurativo y el contenido de las medida?"
                    name="comprende_objetivo"
                    value={safeValue('comprende_objetivo')}
                    onChange={onChange}
                    error={!!safeError('comprende_objetivo')}
                    helperText={safeError('comprende_objetivo')}
                >
                    <MenuItem value="SI">Sí</MenuItem>
                    <MenuItem value="NO">No</MenuItem>
                </TextField>
            </Grid>

            <Grid item xs={12} md={12}>
                <TextField
                    select
                    fullWidth
                    label="¿Acepta participar voluntariamente en el proceso restaurativo y comprometerse con las medidas socializadas?"
                    name="acepta_proceso_restaurativo"
                    value={safeValue('acepta_proceso_restaurativo')}
                    onChange={onChange}
                    error={!!safeError('acepta_proceso_restaurativo')}
                    helperText={safeError('acepta_proceso_restaurativo')}
                >
                    <MenuItem value="SI">Sí</MenuItem>
                    <MenuItem value="NO">No</MenuItem>
                    <MenuItem value="TIEMPO">Requiere tiempo para decidir</MenuItem>
                </TextField>
            </Grid>

            <Grid item xs={12}>
                <Divider style={{ margin: '10px 0' }} />
                <Typography variant="body2" style={{ marginBottom: 20 }}>
                    Yo, <strong>{safeValue('nombre_ofensor') || '________________'}</strong>, declaro que he recibido información clara sobre el proceso restaurativo activado en mi contra, he comprendido las medidas propuestas por la persona afectada y he sido orientado/a sobre su alcance.
                </Typography>
            </Grid>

            {safeValue('acepta_proceso_restaurativo') === 'NO' && (
                <Grid item xs={12}>
                    <Paper elevation={0} style={{ padding: 10, backgroundColor: '#ffebee', border: '1px solid #f44336' }}>
                        <Typography variant="body2" color="error">
                            <strong>Nota:</strong> En caso de respuesta negativa, se cierra esta fase y se continúa con el acompañamiento correspondiente por vías separadas.
                        </Typography>
                    </Paper>
                </Grid>
            )}

            {aceptaParticipar && (
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        multiline
                        rows={4}
                        variant="outlined"
                        label="Observaciones o compromisos iniciales del ofensor"
                        name="observaciones_ofensor"
                        value={safeValue('observaciones_ofensor')}
                        onChange={onChange}
                        error={!!safeError('observaciones_ofensor')}
                        helperText={safeError('observaciones_ofensor')}
                    />
                </Grid>
            )}
        </Grid>
    );
}


export const Formulario008Steps = [
    {
        label: 'Datos de la Persona Ofensora',
        render: (props) => <IdentificacionOfensor {...props} />
    },
    {
        label: 'Socialización y Decisión',
        render: (props) => <SocializacionDecision {...props} />
    }
];